<template>
    <div class="ower__contain">
        <NavSecond :banner="icon_stra" :noNeedCate="true"></NavSecond>
        <div class="wrapper__w">
            <div class="superstars_type animate__animated animate__fadeInUp"><span>业主心声</span></div>
            <div class="ower__box animate__animated animate__fadeInUp">
                <div class="ba"><img :src="baseInfo.background"></div>
                <el-row class="ower__base">
                    <el-col :span="14" class="">
                        <div style="margin-left: 120px;margin-top: 83px;">
                            <div class="brand_type"><span>{{baseInfo.name}}系列作品</span></div>
                            <div style="line-height: 22px" v-html="baseInfo.description"></div>
                        </div>
                    </el-col>
                    <el-col :span="10" class="logo__right">
                        <div class="logo box__pack"><img :src="baseInfo.logo" class=""></div>
                    </el-col>
                </el-row>
            </div>
            <div class="wow animate__fadeInUp" v-html="baseInfo.content"></div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '@/layouts/Footer'
    import icon_stra from '@/assets/img/ower01.png'
    import icon_ower02 from '@/assets/img/ower02.png'
    import icon_ower03 from '@/assets/img/ower03.png'
    import NavSecond from '@/components/NavSecond'
    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,icon_ower02,icon_ower03,
                baseInfo: {}
            }
        },
        components: {
            NavSecond,
            Footer
        },
        methods: {
            /**
             * @description详情
             * */
            getDetail (){
                this.$xhr(this.$api.ownerVoiceDetail, {id: this.$route.query.id}).then(res => {
                    this.baseInfo = res
                })
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getDetail()
            })
        }
    }
</script>
<style  lang="scss" scoped>
    .ower__contain
    {
        .superstars_type, .brand_type{
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            span{
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .ower__box{
            /*width: 85%;*/
            margin: 0 auto;
            margin-bottom: 30px;
            .ba{
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .ower__base{
                height: 300px;
                background: #fff;
                .logo__right{
                    overflow: hidden;
                }
                .logo{
                    float: right;
                    width: 318px;
                    height: 300px;
                    background: #F1F1F1;
                    img{
                        width: 80%;
                        display: block;
                        object-fit: contain;
                        margin: 0 auto;
                    }
                }
            }
            .brand_type{
                position: unset;
                text-align: left;
                font-size: 28px;
                height: unset;
                line-height: unset;
                margin-bottom: 40px;
                span::after{
                    bottom: -10px;
                    left: 0;
                    margin-left: 0;
                }
            }
        }


    }
</style>
